module.exports = __webpack_public_path__ + "static/media/pic2.b021895c.jpg";